import { Component, OnInit, Inject, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { Store } from 'redux';
import { AppStore } from '../../app.store';
import { ConfigState } from '../../_model/config/config.reducer';
import * as configActions from '../../_model/config/config.actions';
import { Subscription } from 'rxjs';
import { RegionService } from '../../_service/region/region.service';
import { ConfigService } from '../../_service/config/config.service';
import { StorageService } from '../../storageprovider';

@Component({
  selector: 'app-dn-region-selector',
  templateUrl: './dn-region-selector.component.html',
  styleUrls: ['./dn-region-selector.component.scss']
})

export class DnRegionSelectorComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  config;
  public expand = false;
  public regions = [
    {
      title: '全球',
      code: 'GL'
    },
    {
      title: '美国',
      code: 'US'
    },
    {
      title: '加拿大',
      code: 'CA'
    },
    {
      title: '英国',
      code: 'UK'
    },
    {
      title: '意大利',
      code: 'IT'
    },
    {
      title: '德国',
      code: 'DE'
    },
    {
      title: '法国',
      code: 'FR'
    },
    {
      title: '西班牙',
      code: 'ES'
    },
    {
      title: '东南亚',
      code: 'MY'
    },
    {
      title: '澳洲',
      code: 'AU'
    },
    {
      title: '日本',
      code: 'JP'
    },
    {
      title: '新西兰',
      code: 'NZ'
    },
    {
      title: '韩国',
      code: 'KR'
    },
    {
      title: '新加坡',
      code: 'SG'
    },
  ];

  public selectedRegion = this.regions[0];
  public subscripted = null;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.expand = false;
    }
  }

  testUrl = 'url(' + '../../../assets/images/footer/GL.png' + ')';

  constructor(
    private _regionService: RegionService,
    private _configService: ConfigService,
    private _storage: StorageService,
    private eRef: ElementRef,
    @Inject(AppStore) private store: Store<ConfigState>,
  ) {
    this.subscripted = store.subscribe(() => this.readState());
    this.readState();
  }

  readState() {
    const state = this.store.getState()['config'];
    this.config = state;


    const r = this.getRegionByCode(this._storage.GetConfig()['region']);
    if (r.length > 0) {
      this.selectedRegion = { title: r[0].title, code: r[0].code };
    }
  }

  ngOnInit() {

  }

  onMouseEnter() {
    this.expand = true;
  }

  onMouseLeave() {
    this.expand = false;
  }

  selectRegion(title, code) {
    if (this.selectedRegion.code !== code) {
      this._configService.setConfig('region', code === 'GL' ? 'GL.' : code);
      this.subscriptions.push(
        this._regionService.switchRegion(code === 'GL' ? 'GL.' : code).subscribe(res => {
          this.store.dispatch({
            type: configActions.UPDATEREGION,
            config: {
              region: code === 'GL' ? 'GL.' : code,
              logoUrl: res.largeLogo.replace("rv19","rv20"),
            }
          });
        })
      );
    }
    this.selectedRegion = { title: title, code: code };
    this.expand = false;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscripted();
  }

  getRegionByCode(code) {
    return this.regions.filter(r => r.code === code);
  }
}
